import {
  PillStyle,
} from '../styled';
import {
  ToggleButton,
} from '../ui';
import { composeHOC } from './utils';

export const PillToggle = composeHOC(PillStyle, ToggleButton);
export { default as ArrowButton } from './ArrowButton.vue';
